import { Flex, Icon, Text } from '@ttoss/ui';
import { Modal } from '@ttoss/components';
import Button from '../Button/Button';

type ModalSuccessProps = {
  message: string;
  isOpen?: boolean;
  buttonLabel: string;
  onClickButton: () => void;
};

export const ModalSuccess = ({
  buttonLabel,
  message,
  onClickButton,
  isOpen,
}: ModalSuccessProps) => {
  return (
    <Modal
      style={{
        content: {
          border: 0,
          borderRadius: '6px',
        },
        overlay: {
          backgroundColor: 'rgba(18, 117, 71, 0.7)',
        },
      }}
      isOpen={isOpen}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          paddingX: 8,
          paddingY: 10,
          alignItems: 'center',
        }}
      >
        <Text sx={{ marginBottom: '40px', fontSize: 3 }}>{message}</Text>

        <Button
          sx={{
            width: '100%',
            maxWidth: '247px',
            display: 'flex',
            gap: 3,
            alignItems: 'center',
          }}
          onClick={onClickButton}
        >
          {buttonLabel}
          <Icon
            sx={{ marginLeft: 5, color: 'background', lineHeight: 0 }}
            icon="bi:arrow-right"
          />
        </Button>
      </Flex>
    </Modal>
  );
};
